"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("bootstrap");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const Cookies = require("js-cookie");
require("font-awesome/css/font-awesome.min.css");
require("jquery-address");
const Clipboard_1 = require("../../TdWebtoolkitControls/controls/Clipboard/Clipboard");
require("../../TdWebtoolkitControls/controls/ErrorDialog/ErrorDialog.js");
require("../../TdWebtoolkitControls/controls/Mail/Mail");
const MethodManager_1 = require("../../TdWebtoolkitControls/controls/Menu/MethodManager");
require("../../TdWebtoolkitControls/controls/Preview/Preview");
require("../../TdWebtoolkitControls/javascript/initialization.js");
require("../../TdWebtoolkitControls/javascript/KendoCultures");
const LocalStorageManager_1 = require("../../TdWebtoolkitControls/javascript/LocalStorageManager");
const Utilities_1 = require("../../TdWebtoolkitControls/javascript/Utilities");
require("../../TdWebtoolkitControls/less/app.less");
require("../../TdWebtoolkitControls/less/app1.less");
require("../less/custom.less");
require("../less/SynApp.less");
const v = require("../views/SynView");
const WaitConditions_1 = require("./WaitConditions");
const $ = require("jquery");
const Instance_1 = require("../../TdWebtoolkitControls/model/Instance");
const MethodServerResponse_1 = require("../../TdWebtoolkitControls/model/MethodServerResponse");
class HistoryItem {
    // do not change the member names!
    constructor(id, name, favorite) {
        this.id = id;
        this.name = name;
        this.favorite = favorite;
    }
}
class SynApp {
    //#region CONSTRUCTORS
    constructor() {
        this.m_history = [];
        this.m_isReady = false;
        this.m_views = [];
        const that = this;
        that.m_clientDeviceClass = Utilities_1.synUtil.clientDeviceClass;
        that.m_refreshes = [];
        $.address.change(() => { that.onAddressChange(); });
    }
    //#endregion MEMBER VARIABLES
    //#region MEMBER METHODS
    run() {
        const that = this;
        $("body").addClass("device_" + that.m_clientDeviceClass);
        that.showUI(false);
        const date = new Date();
        date.setTime(date.getTime() + 30000); // 30s in future
        Cookies.set("fromAppLogon", "Y", { expires: date, path: "/" });
        Utilities_1.synUtil.logonCheck({
            done: (data) => {
                that.m_checkAutoLogOffSeconds = Math.round(data.timeoutSeconds) + 10;
                kendo.culture(Utilities_1.synUtil.userCulture);
                switch (Utilities_1.synUtil.userLanguage) {
                    case "de":
                        require("../../node_modules/@progress/kendo-ui/js/messages/kendo.messages.de-AT.js");
                        /* DateInput */
                        if (kendo.ui.DateInput) {
                            kendo.ui.DateInput.prototype.options.messages =
                                $.extend(true, kendo.ui.DateInput.prototype.options.messages, {
                                    "year": "Jahr",
                                    "month": "Monat",
                                    "day": "Tag",
                                    "weekday": "Wochentag",
                                    "hour": "Stunden",
                                    "minute": "Minuten",
                                    "second": "Sekunden",
                                    "dayperiod": "AM/PM"
                                });
                        }
                        break;
                    case "en":
                        require("../../node_modules/@progress/kendo-ui/js/messages/kendo.messages.en-US.js");
                        break;
                }
                that.runAsyncCalls().then(() => {
                    if (that.m_clientDeviceClass === "desktop") {
                        if (data.forceWorkspaceDisabled)
                            Utilities_1.synUtil.synerisWorkspaceDisabled = true;
                        else {
                            Utilities_1.synUtil.synerisWorkspaceDisabled = false;
                            if (data.forceWorkspaceEnabled)
                                Utilities_1.synUtil.hasSynerisWorkspace = true;
                        }
                    }
                    that.renderUserMenu();
                    that.updateWorkspaceCheckBox();
                });
            },
            cleanUp: (jqhxr) => {
                if (typeof jqhxr.status === "undefined" && jqhxr.status !== 403 || jqhxr.status === 500)
                    that.showUI(true);
            }
        });
        // Enable confirmation on window close or reload
        window.onbeforeunload = (event) => {
            var _a;
            if (((_a = that.m_selectedView) === null || _a === void 0 ? void 0 : _a.m_UIDisabled) && Utilities_1.synUtil.Configs.getValue("webconfirmcancel") !== "N") {
                event.preventDefault();
                event.returnValue = '';
                return "";
            }
        };
        kendo.ui.Window.fn["_keydown"] = function (originalFn) {
            return function (e) {
                var _a;
                if (e.which === 27)
                    if (!(((_a = this.element) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.element.hasClass("synPreventCloseOnEscape")))
                        originalFn.call(this, e);
            };
        }(kendo.ui.Window.fn["_keydown"]);
        // Enable shortcut events
        $(window).keydown(function (event) {
            var _a;
            const kendoWindowOpen = (Utilities_1.synUtil.IsKendoWindowOpen());
            if (event.ctrlKey && event.keyCode === 83) {
                // Ctrl+S
                if (!kendoWindowOpen) {
                    // Hinweis: Solange ein KendoWindow offen ist, verarbeiten wir keine ShortCuts. Ansonsten würde bei geöffnetem Multivalue-Dialog ein CTRL+S ein Speichern auslösen und die
                    // gesamte Applikation würde außer Tritt kommen.
                    // IE11 fallback (activeElement can be undefined)
                    if (document.activeElement == undefined)
                        $("body").trigger("cmdSave");
                    else
                        $(document.activeElement).trigger("cmdSave");
                }
                event.preventDefault(); // Abspeichern der HTML-Seite wollen wir auf keinen Fall!
            }
            // Deactivate other shortcuts for disabled UI in views or if a kendoWindow is open
            if (((_a = that.m_selectedView) === null || _a === void 0 ? void 0 : _a.m_UIDisabled) || (kendoWindowOpen))
                return;
            function isTextBox(element) {
                const tagName = element.tagName.toLowerCase();
                if (tagName === 'textarea')
                    return true;
                if (tagName !== 'input')
                    return false;
                const type = element.getAttribute('type').toLowerCase();
                const inputTypes = ['text', 'password', 'number', 'email', 'tel', 'url', 'search', 'date', 'datetime', 'datetime-local', 'time', 'month', 'week'];
                return inputTypes.indexOf(type) >= 0;
            }
            if (event.ctrlKey && event.keyCode === 67) {
                // Ctrl+C (Only when no text is selected)
                let userSelection = "";
                if (isTextBox(event.target))
                    userSelection = event.target.value.substring(event.target.selectionStart, event.target.selectionEnd);
                else
                    userSelection = window.getSelection().toString();
                if (userSelection === "") {
                    $(document.activeElement).trigger("cmdCopy");
                    event.preventDefault();
                }
            }
            else if (event.ctrlKey && event.keyCode === 86) {
                // Ctrl+V
                if (!isTextBox(event.target)) {
                    $(document.activeElement).trigger("cmdPaste");
                    event.preventDefault();
                }
            }
            else if (event.ctrlKey && event.keyCode === 88) {
                // Ctrl+X (Only when no text is selected)
                let userSelection = "";
                if (isTextBox(event.target))
                    userSelection = event.target.value.substring(event.target.selectionStart, event.target.selectionEnd);
                else
                    userSelection = window.getSelection().toString();
                if (userSelection === "") {
                    $(document.activeElement).trigger("cmdCut");
                    event.preventDefault();
                }
            }
        });
        // Catch shortcut events if they bubble up
        $(window).on("cmdCopy", function (e) {
            MethodManager_1.MethodManager.executeMethodWithoutMenu(Clipboard_1.CopyMethod, that.m_selectedView.CommandLayouts.SelectionContext.FullSelectionContext, that.m_selectedView.CommandTriggerTarget);
        });
        $(window).on("cmdPaste", function (e) {
            MethodManager_1.MethodManager.executeMethodWithoutMenu(Clipboard_1.PasteMethod, that.m_selectedView.CommandLayouts.SelectionContext.FullSelectionContext, that.m_selectedView.CommandTriggerTarget);
        });
        $(window).on("cmdCut", function (e) {
            MethodManager_1.MethodManager.executeMethodWithoutMenu(Clipboard_1.CutMethod, that.m_selectedView.CommandLayouts.SelectionContext.FullSelectionContext, that.m_selectedView.CommandTriggerTarget);
        });
        $(window).on("cmdSave", function (e) {
            // Give the current view a chance to react to the shortcut (if the focused element was outside the view)
            that.m_selectedView.m_$container.trigger("viewcmdSave");
        });
        // Respond to forceRefreshSelectedView trigger
        $(window).on("forceRefreshSelectedView", (e, modificationInfo) => {
            this.forceRefreshSelectedView(modificationInfo);
        });
    }
    //#region Helpers
    runAsyncCalls() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Utilities_1.synUtil.Configs.init();
            yield Utilities_1.synUtil.Strings.init();
            yield Utilities_1.synUtil.UserInfo.init();
            this.loadHistory();
            this.initApp();
        });
    }
    forceRefreshSelectedView(modificationInfo) {
        if (this.m_selectedView)
            this.m_selectedView.forceRefresh(modificationInfo);
    }
    getViewIdFromPath() {
        if ($.address.path() === "/") {
            if (this.m_views.length > 0)
                return this.m_views[0].viewName;
            return undefined;
        }
        else
            return $.address.path().substring(1);
    }
    onAddressChange() {
        const that = this;
        if (that.m_isReady) {
            // Bei jeder Änderung der URL
            $.address.autoUpdate(true);
            const viewName = that.getViewIdFromPath();
            if (viewName) {
                $("body").addClass("device_" + that.m_clientDeviceClass);
                if (that.m_clientDeviceClass === "phone")
                    $("#navbar:visible").collapse("hide");
                if (that.m_selectedView == undefined || viewName !== that.m_selectedView.viewName) {
                    $("#ViewButtons").children().remove();
                    $("#MenuContainer").find(".menu").hide();
                    $("#MenuContainer").find(".btn").remove();
                    const matches = $.grep(that.m_views, function (curView) {
                        return curView.viewName === viewName;
                    });
                    if (matches.length === 1)
                        that.selectView(matches[0]);
                    else {
                        v.SynView.getView(viewName, 0, (synView) => {
                            if (synView) {
                                that.bindEvents(synView);
                                that.selectView(synView);
                            }
                        });
                    }
                }
            }
        }
    }
    bindEvents(view) {
        const that = this;
        view.onViewButtonsReady = that.viewButtonsReceived.bind(that);
        view.onViewMenuResize = that.viewMenuResize.bind(that);
        view.onRefresh = that.viewRefresh.bind(that);
        view.onViewHistory = that.viewAddToHistory.bind(that);
        view.onViewMadeChanges = that.viewMadeChanges.bind(that);
        view.onViewGetMenu = that.getMenu.bind(that);
        view.onViewSetMenu = that.setMenu.bind(that);
        view.onViewGetIsActive = that.getIsActive.bind(that);
    }
    getMenu(view) {
        if (this.m_$MainMenu == undefined)
            return $();
        return this.m_$MainMenu;
    }
    setMenu(view, $newMenu) {
        this.m_$MainMenu = $newMenu.appendTo($(".topBar > .topBarMenuContainer").html(""));
    }
    getIsActive(view) {
        return this.getViewIdFromPath() === view.viewName;
    }
    selectView(view) {
        if (view) {
            const that = this;
            if (that.m_selectedView) {
                that.m_selectedView.deactivate();
                that.m_selectedView;
            }
            that.m_selectedView = view;
            that.m_selectedView.activate();
            that.m_layout.showIn("#viewHolder", that.m_selectedView.view);
            that.m_selectedView.createContents($("#viewHolder"));
            that.refreshAppContainer();
            that.highlightSelectedView();
            that.highlightHistoryEntry(undefined);
            // Dispatch refreshes generated in other views
            for (let i = 0; i < that.m_refreshes.length; ++i) {
                const curRefresh = that.m_refreshes[i];
                if (curRefresh.viewMap[view.m_viewName]) {
                    view.forceRefresh(curRefresh.modificationInfo);
                    delete curRefresh.viewMap[view.m_viewName];
                }
            }
            // Remove refreshes that have been dispatched to all views
            that.m_refreshes = that.m_refreshes.filter(r => Object.keys(r.viewMap).length > 0);
        }
    }
    highlightSelectedView() {
        $(".sideNav > .views").children("div.synView").removeClass("active");
        if (this.m_selectedView)
            $("div.synView[data-viewname='" + this.m_selectedView.viewName + "']").addClass("active");
    }
    initSearchBox() {
        const that = this;
        const searchField = Utilities_1.synUtil.Configs.getValue("webtoolkit.searchfield");
        if (searchField) {
            const title = Utilities_1.synUtil.Strings.getValue(searchField + ".1", searchField);
            const $textBox = $(".searchWrapper").show().children("input").val("");
            const $searchButton = $(".searchWrapper").children("a.k-icon");
            $textBox
                .attr({ "placeholder": title, "data-searchfield": searchField })
                .off("keyup").on("keyup", function (e) {
                if (e.which === 13)
                    that.search($textBox.val(), $textBox.attr("data-searchfield"));
            });
            $searchButton.on("click", () => {
                that.search($textBox.val(), $textBox.attr("data-searchfield"));
            });
        }
        else // hide searchbox when no use-case is set
            $(".searchWrapper").removeAttr("style").hide();
    }
    search(searchText, searchField) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (searchText) {
                const searchInstance = yield Instance_1.Instance.fromSearchData({
                    "cgdocument.typeid": "1",
                    "cgexplorer.childs": "Y"
                });
                yield searchInstance.addSearchField(searchField, searchText);
                Utilities_1.synUtil.beginAjaxProgress();
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("Search"),
                    requestData: {
                        maxResults: 2,
                        query: JSON.stringify(searchInstance.toJSON())
                    },
                    done(data, textStatus, jqXHR, handlerKey) {
                        Utilities_1.synUtil.beginAjaxProgress();
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("Results") + data,
                            headers: { "X-WS-Affinity": handlerKey },
                            requestData: { oneShot: true, fieldNames: JSON.stringify(["id"]) },
                            done(dataJSON) {
                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    const instances = yield Instance_1.Instance.fromJSONArray(dataJSON.data);
                                    if (dataJSON.total === 0)
                                        Utilities_1.synUtil.Notifications.error(kendo.format(Utilities_1.synUtil.Strings.getValue("ERROR_200000|5"), searchField, searchText));
                                    else if (dataJSON.total > 1)
                                        Utilities_1.synUtil.Notifications.error(kendo.format(Utilities_1.synUtil.Strings.getValue("ERROR_200000|4"), searchField, searchText));
                                    else
                                        window.open("#/properties?id=" + instances[0].id.value, "_blank");
                                });
                            },
                            cleanUp: () => {
                                Utilities_1.synUtil.endAjaxProgress();
                            }
                        });
                    },
                    cleanUp: () => {
                        Utilities_1.synUtil.endAjaxProgress();
                    }
                });
            }
        });
    }
    initViewButtons() {
        const that = this;
        $.each(that.m_views, function (idx, view) {
            const viewNameEsc = Utilities_1.synUtil.escapeHTMLAttribute(view.viewName);
            const viewTitleEsc = Utilities_1.synUtil.escapeHTMLAttribute(view.title);
            const viewIconEsc = Utilities_1.synUtil.escapeHTMLAttribute(view.icon);
            const div = $("<div class='synView' data-viewname='" + viewNameEsc + "'></div>").appendTo($(".sideNav > .views"));
            const hyperlink = $("<a href='#/" + viewNameEsc + "' title='" + viewTitleEsc + "'></a>")
                .on("click", function (e) {
                if ($(this).parent().hasClass("active") || $(this).parent().hasClass("disabled"))
                    e.preventDefault();
            })
                .appendTo(div);
            hyperlink.append($("<i></i>").addClass(viewIconEsc));
            hyperlink.append($("<span></span>").addClass("text").text(view.title));
        });
    }
    initApp() {
        const that = this;
        that.checkUserLoggedin();
        $(window)
            .resize(function () {
            const curWindowWidth = $(window).width();
            const curWindowHeight = $(window).height();
            if (curWindowWidth !== that.lastWindowWidth || curWindowHeight !== that.lastWindowHeight) {
                that.lastWindowWidth = curWindowWidth;
                that.lastWindowHeight = curWindowHeight;
                that.refreshAppContainer();
            }
        })
            .focus(() => {
            if ($("#Clipboard").synClipboard)
                $("#Clipboard").synClipboard("refresh");
            that.raiseFocus();
        })
            .blur(() => {
            that.raiseBlur();
        });
        that.setUpAppContainer();
        that.render();
        that.initSearchBox();
        that.loadViews((views) => {
            that.m_views = views;
            that.initViewButtons();
            const viewId = that.getViewIdFromPath();
            if (that.m_views.length > 0 && viewId === that.m_views[0].viewName)
                that.selectView(that.m_views[0]);
            if (typeof window.synDesktopApp !== "undefined")
                window.synDesktopApp.set_webAppReady(true);
            if (typeof window.synDesktopView !== "undefined")
                window.synDesktopView.set_webAppReady(true);
            that.m_isReady = true;
            $.address.path(viewId);
            $.address.update();
            $.address.externalChange(function (event) {
                if (that.m_selectedView && that.m_selectedView.viewName === that.getViewIdFromPath()) {
                    that.m_selectedView.getParametersFromUrl();
                    that.m_selectedView.recreateMenu();
                    that.m_selectedView.updateSelectionContext();
                    that.m_selectedView.resizeMenu();
                }
            });
            that.showUI(true);
        });
    }
    viewButtonsReceived(buttons) {
        const that = this;
        const viewButtonContainer = $(".topBarRight .viewButtons").html("");
        for (let i = 0; i < buttons.length; i++) {
            const btn = buttons[i];
            const button = $("<button type='button' data-id='" + btn.m_id + "' class='btn' title='" + btn.m_title + "' />")
                .appendTo(viewButtonContainer);
            if (btn.m_toggleable) {
                button.attr("data-toggle", "button")
                    .on("click", (evt) => {
                    const $button = $(evt.target).closest("button");
                    if ($button.hasClass("active")) {
                        $button.removeClass("btn-primary");
                        if ("phone" === that.m_clientDeviceClass)
                            return;
                    }
                    else {
                        $button.addClass("btn-primary");
                        if ("phone" === that.m_clientDeviceClass)
                            $button.siblings("button.btn").removeClass("btn-primary active");
                    }
                    btn.m_clickHandler($button.attr("data-id"), !$button.hasClass("active"));
                    $("#Preview").synPreview("recreateAsync").then(() => {
                        $("#Preview").synPreview("resize");
                    });
                });
                if (btn.m_initiallyActivated)
                    button.addClass("active btn-primary").attr("aria-pressed", "true");
            }
            else
                // eslint-disable-next-line no-null/no-null
                button.on("click", function () { btn.m_clickHandler($(this).attr("data-id"), null); });
            button.append("<i class='fa " + btn.m_icon + "' />");
        }
        if (that.m_selectedView)
            that.m_selectedView.resizeMenu();
    }
    viewMenuResize(view, requiredHeight) {
        $(".appContainer").data("kendoSplitter").size(".k-pane:first", Math.round(requiredHeight).toString());
        this.resizeWidgets(false);
    }
    viewRefresh(view, modificationInfo) {
        const refreshInfo = {
            modificationInfo,
            viewMap: {}
        };
        const viewNames = this.m_views.map(v => v.m_viewName);
        for (let i = 0; i < viewNames.length; ++i) {
            const viewName = viewNames[i];
            if (viewName !== view.m_viewName)
                refreshInfo.viewMap[viewName] = true;
        }
        this.m_refreshes.push(refreshInfo);
    }
    viewAddToHistory(view, instanceId, instanceName, highlight) {
        this.addHistoryEntry(instanceId, instanceName);
        if (highlight)
            this.highlightHistoryEntry(instanceId);
    }
    viewMadeChanges(view) {
        $.each(this.m_views, function (idx, curView) {
            if (curView.viewName !== view.viewName)
                curView.refreshNecessary = true;
        });
    }
    loadViews(done) {
        const that = this;
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("ProfileViews"),
            done(data) {
                if (data && data.length > 0) {
                    const views = [];
                    let unfinished = data.length;
                    $.each(data, (idx, view) => {
                        v.SynView.getView(view.name, idx, (synView) => {
                            if (synView) {
                                synView.editableFavorites = view.editableFavorites || false;
                                that.bindEvents(synView);
                                views.push(synView);
                            }
                            if (--unfinished === 0) {
                                views.sort((a, b) => a.viewIndex - b.viewIndex);
                                done(views);
                            }
                        });
                    });
                }
                else
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("noviewprofiles"));
            },
            fail(jqXHR, textStatus, errorThrown, url) {
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("noviewprofiles"));
            }
        });
    }
    setUpAppContainer() {
        // Application-wide containers
        const that = this;
        $(".appContainer")
            .show()
            .kendoSplitter({
            orientation: "vertical",
            panes: [
                {
                    resizable: false,
                    scrollable: false,
                    collapsible: true,
                    collapsed: false,
                    size: "60px"
                }, {
                    resizable: false,
                    scrollable: false,
                    collapsible: true,
                    collapsed: true,
                    size: "60px"
                }, {
                    resizable: false,
                    scrollable: false
                }
            ]
        });
        $(".appContainer").show();
        $(".innerContainer").kendoSplitter({
            orientation: "horizontal",
            panes: [
                {
                    resizable: true,
                    collapsible: true,
                    min: SynApp.SideNavMinWidth + "px",
                    max: SynApp.SideNavMaxWidth + "px",
                    scrollable: false,
                    size: SynApp.SideNavMinWidth + "px"
                }, {
                    resizable: true,
                    scrollable: false
                }
            ]
        });
        const overrideSideNavColor = Utilities_1.synUtil.Configs.getValue("webtoolkit.overridesidenavcolor", undefined);
        if (overrideSideNavColor)
            $(".sideNav, .synerisLogo, .logoSpacer").css("background-color", overrideSideNavColor);
        $(".synerisLogo, .logoSpacer").css("width", SynApp.SideNavMinWidth + "px");
        if (Utilities_1.synUtil.clientDeviceClass !== "phone") {
            const toggleSideNav = function (sideNav) {
                const $this = $(sideNav);
                const splitter = $(".innerContainer").data("kendoSplitter");
                const $history = $(".sideNav > .history");
                if ($this.attr("data-expanded") === "true") {
                    $(".synerisLogo, .logoSpacer").css("width", SynApp.SideNavMinWidth + "px");
                    $(".sideNav").removeClass("expanded");
                    splitter.size(".sideNav", SynApp.SideNavMinWidth + "px");
                    $(".logoSpacer").css("width", SynApp.SideNavMinWidth + "px");
                    $this.removeAttr("data-expanded");
                    LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.SideNav, "isExpanded", "false");
                }
                else {
                    $(".sideNav").addClass("expanded");
                    $(".synerisLogo, .logoSpacer").css("width", SynApp.SideNavMaxWidth + "px");
                    splitter.size(".sideNav", SynApp.SideNavMaxWidth + "px");
                    $(".logoSpacer").css("width", SynApp.SideNavMaxWidth + "px");
                    $this.attr("data-expanded", "true");
                    that.fixHistoryWidths();
                    LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.SideNav, "isExpanded", "true");
                }
                that.resizeWidgets(true);
            };
            $(".synerisLogo").on("click", function () {
                const sideNav = this;
                toggleSideNav(sideNav);
            });
            const isExpanded = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.SideNav, "isExpanded");
            if (isExpanded && isExpanded === "true")
                toggleSideNav($(".synerisLogo"));
        }
        window.waitConditions.set("appContainerReady");
    }
    loadHistory() {
        const items = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.History, "historyItems");
        if (items)
            this.m_history = JSON.parse(items);
        else
            this.m_history = [];
    }
    saveHistory() {
        LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.History, "historyItems", JSON.stringify(this.m_history));
    }
    deleteHistoryEntry(id, update = true) {
        this.m_history = $.grep(this.m_history, (item) => { return item.id !== id; });
        if (update) {
            this.saveHistory();
            this.renderHistory();
        }
    }
    getHistoryEntry(id) {
        const matches = $.grep(this.m_history, (item) => { return item.id === id; });
        if (matches.length)
            return matches[0];
        return undefined;
    }
    addHistoryEntry(id, name) {
        // Only add if it doesn't already exist
        const presentItemsForId = $.grep(this.m_history, (hi) => {
            return hi.id === id;
        });
        if (!presentItemsForId.length) {
            const newItem = new HistoryItem(id, name, false);
            // Add to top
            this.m_history.splice(0, 0, newItem);
            while (this.m_history.length >= SynApp.MaxHistoryItems) {
                // We have exceeded max history count. Remove last non-favourited entry, if it exists,
                // otherwise last entry
                for (let i = this.m_history.length - 1; i >= 0; --i) {
                    const curItem = this.m_history[i];
                    if (!curItem.favorite && curItem.id !== id) {
                        this.m_history.splice(i, 1);
                        break;
                    }
                    else if (i === 0)
                        this.m_history.splice(this.m_history.length - 1, 1);
                }
            }
            this.saveHistory();
            this.renderHistory();
        }
    }
    highlightHistoryEntry(id) {
        const $history = $(".sideNav > .history");
        $history.children(".item").removeClass("active");
        if (id)
            $history.children(".item[data-id='" + id + "']").addClass("active");
    }
    renderNotifications() {
        const updateIcon = function (notificationInfo) {
            const notifications = $(".staticButtons .notifications")
                .off("click")
                .on("click", function () {
                MethodManager_1.MethodManager.executeMethod("synnotificationext.1", [], undefined, 0, undefined, undefined);
            });
            if (notificationInfo && (notificationInfo.read + notificationInfo.unread) > 0) {
                notifications.show();
                if (notificationInfo.unread > 0)
                    notifications.find("span.badge").css("display", "inline-block").text(notificationInfo.unread.toString());
                else
                    notifications.find("span.badge").css("display", "none");
            }
            else
                notifications.hide();
        };
        Utilities_1.synUtil.executeMethod({
            method: "synnotificationext.3",
            done(dataJSON) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    const data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                    const info = data.additionalInformation;
                    if ("false" === info["synnotificationext.3iconenabled"])
                        $(".staticButtons .notifications").hide();
                    else if (info["synnotificationext.3read"])
                        updateIcon({
                            read: parseInt(info["synnotificationext.3read"], 10),
                            unread: parseInt(info["synnotificationext.3unread"], 10)
                        });
                });
            },
            fail(jqXHR, textStatus, errorThrown, url) {
                $(".staticButtons .notifications").hide();
            }
        });
    }
    renderMailButton() {
        const that = this;
        $(".staticButtons .mails")
            .on("afterInsert", function () {
            if (that.m_selectedView)
                that.m_selectedView.forceRefresh(undefined);
        })
            .on("needContext", function () {
            let selectionContext;
            if (that.m_selectedView)
                selectionContext = that.m_selectedView.CommandLayouts.SelectionContext.getSelectionContextForMethod(true);
            if (selectionContext)
                $(".staticButtons .mails").data("synMail").context = selectionContext;
        })
            .synMail({});
    }
    renderCheckedOutDocButton() {
        $(".staticButtons .checkedOutDocuments .headline").text(Utilities_1.synUtil.Strings.getValue("syncheckedoutdocuments"));
        const $listView = $(".staticButtons .checkedOutDocuments .checkedOutListView");
        const $pager = $(".staticButtons .checkedOutDocuments .checkedOutPager");
        const $bagde = $(".staticButtons .checkedOutDocuments span.badge");
        const getCheckedOutDocuments = (onlyCount, callback, skip, take) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const searchInstance = yield Instance_1.Instance.fromSearchData({
                "cgdocument.typeid": "999999981",
                "cgexplorer.childs": "Y",
                "cgdocument.chkout": "Y",
                "cgdocument.doclock": "Y",
                "cgdocument.doclockby": "#variable.currentuser#"
            });
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: onlyCount ? Utilities_1.synUtil.getWSUrl("Count") : Utilities_1.synUtil.getWSUrl("Search"),
                requestData: { query: JSON.stringify(searchInstance.toJSON()) },
                done(data, textStatus, jqXHR, handlerKey) {
                    if (onlyCount)
                        callback(data);
                    else {
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("Results") + data + "/" + skip.toString() + "/" + take.toString(),
                            headers: { "X-WS-Affinity": handlerKey },
                            requestData: { oneShot: onlyCount ? "true" : "false" },
                            done(data2) {
                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    data2.data = yield Instance_1.Instance.fromJSONArray(data2.data);
                                    callback(data2);
                                });
                            }
                        });
                    }
                }
            });
        });
        const checkedOutDataSource = new kendo.data.DataSource({
            pageSize: 20,
            serverPaging: true,
            schema: { data: "data", total: "total" },
            transport: {
                read(options) {
                    getCheckedOutDocuments(false, (data) => {
                        options.success(data);
                    }, options.data.skip, options.data.take);
                }
            }
        });
        $listView.kendoListView({
            autoBind: false,
            template: kendo.template("<div data-id='#=id.value#' class='checkedOutDoc'><a href='javascript:void(0)'><img class='icon' src='" + Utilities_1.synUtil.getWSUrl("Icon") + "#= icon.value#/16'></img><span class='category'>#: data.items[\"cgdoctype.name\"].value #</span>:&nbsp;<span class='name'>#: name.value #</span></a></div>"),
            dataSource: checkedOutDataSource,
            dataBound() {
                $listView.find("div.checkedOutDoc").on("click", function () {
                    const id = $(this).attr("data-id");
                    MethodManager_1.MethodManager.executeMethod("cefunc.2", [id], undefined, undefined, undefined, { newWindow: true });
                });
            }
        });
        $pager.kendoPager({
            dataSource: checkedOutDataSource,
            messages: {
                display: Utilities_1.synUtil.Strings.getValue("listdisplay"),
                empty: Utilities_1.synUtil.Strings.getValue("listemtpy"),
                page: Utilities_1.synUtil.Strings.getValue("listpage"),
                of: Utilities_1.synUtil.Strings.getValue("listof"),
                itemsPerPage: Utilities_1.synUtil.Strings.getValue("listitemsperpage"),
                first: Utilities_1.synUtil.Strings.getValue("listfirstpage"),
                previous: Utilities_1.synUtil.Strings.getValue("listpreviouspage"),
                next: Utilities_1.synUtil.Strings.getValue("listnextpage"),
                last: Utilities_1.synUtil.Strings.getValue("listlastpage"),
                refresh: Utilities_1.synUtil.Strings.getValue("refresh")
            }
        });
        const $checkedOutDocMenu = $(".staticButtons .checkedOutDocuments")
            .off("shown.bs.dropdown").on("shown.bs.dropdown", () => { $listView.data("kendoListView").dataSource.read(); });
        if ("phone" === this.m_clientDeviceClass) {
            $(".checkedOutDocumentsMenu").css({
                "width": document.documentElement.clientWidth + "px",
                "padding": "0px",
                "left": "-343px"
            });
        }
        $(".checkedOutDocumentsMenu").on("click", function (event) {
            let events = $._data(document, "events") || {};
            events = events.click || [];
            for (let i = 0; i < events.length; i++) {
                if (events[i].selector) {
                    // Check if the clicked element matches the event selector
                    if ($(event.target).is(events[i].selector))
                        events[i].handler.call(event.target, event);
                    // Check if any of the clicked element parents matches the
                    // delegated event selector (Emulating propagation)
                    $(event.target).parents(events[i].selector).each(function () {
                        events[i].handler.call(this, event);
                    });
                }
            }
            event.stopPropagation(); // Always stop propagation
        });
        getCheckedOutDocuments(true, (data) => {
            $bagde.text(data.toString());
            $checkedOutDocMenu.toggle(data > 0);
        });
    }
    renderClipboard() {
        const that = this;
        $("#Clipboard")
            .on("needContext", function () {
            let selectionContext;
            if (that.m_selectedView)
                selectionContext = that.m_selectedView.CommandLayouts.SelectionContext.FullSelectionContext;
            if (selectionContext)
                $("#Clipboard").data("synClipboard").context = selectionContext;
        })
            .off("afterPaste").on("afterPaste", function (event, ids) {
            if (that.m_selectedView)
                that.m_selectedView.forceRefresh(undefined);
        })
            .synClipboard();
    }
    showMailButton() {
        $(".staticButtons .mails").show();
    }
    renderChangeButtons() {
        $(".changeBar .btn.save").append(kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("menusave")));
        $(".changeBar .btn.saveAndClose").append(kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("menusaveandclose")));
        $(".changeBar .btn.cancel").append(kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("menucancel")));
    }
    renderStaticButtons() {
        this.renderNotifications();
        this.renderMailButton();
        this.renderCheckedOutDocButton();
        this.renderClipboard();
    }
    updateWorkspaceCheckBox() {
        const icon = $(".userMenu [data-command='toggleWorkspace'] i");
        if (Utilities_1.synUtil.useSynerisWorkspace)
            icon.removeClass("fa-square-o").addClass("fa-check-square-o");
        else
            icon.removeClass("fa-check-square-o").addClass("fa-square-o");
    }
    renderUserMenu() {
        const that = this;
        const userName = Cookies.get("userString") || "";
        that.updateWorkspaceCheckBox();
        // Logout
        $(".userMenu .logoutText").text(Utilities_1.synUtil.Strings.getValue("weblogout") + " " + userName);
        // Change PWD
        if ("Y" === Cookies.get("passwordChangeable"))
            $(".userMenu [data-command='changePwd']").css("display", "");
        $(".userMenu .changePwdText").text(Utilities_1.synUtil.Strings.getValue("pasdlgcaption"));
        // Use Workspace
        $(".userMenu .toggleWorkspaceText").text(Utilities_1.synUtil.Strings.getValue("useworkspace"));
        // Command handling
        $(".userMenu li > a:not([href])").off("click").on("click", function (evt) {
            const command = $(this).closest("li").attr("data-command");
            if ("logout" === command)
                Utilities_1.synUtil.logout();
            else if ("changePwd" === command)
                MethodManager_1.MethodManager.executeMethod("admfunc.6", [], undefined, 0, undefined, undefined);
            else if ("toggleWorkspace" === command) {
                Utilities_1.synUtil.hasSynerisWorkspace = !Utilities_1.synUtil.useSynerisWorkspace;
                that.updateWorkspaceCheckBox();
                that.showMailButton();
                evt.stopPropagation();
            }
        });
        if (!Utilities_1.synUtil.synerisWorkspaceDisabled && this.m_clientDeviceClass === "desktop") {
            $(".userMenu [data-command='toggleWorkspace'],li.separator").css("display", "");
            that.showMailButton();
        }
    }
    fixHistoryWidths() {
        const $history = $(".sideNav > .history");
        $history.find("div.text").css("width", ($history.innerWidth() - 48) + "px");
    }
    renderHistory() {
        const that = this;
        const $history = $(".sideNav > .history").html("");
        for (let i = 0; i < that.m_history.length; i++) {
            const tmpl = kendo.template("<div class='item' data-id='#=id#' title='#:name#'>"
                + "<div class='button favButton'><a href='javascript:;'><span><i class='histButton fa #= (favorite? \"fa-star\" : \"fa-star-o\")#' /></i></span></a></div>"
                + "<div class='text'><a href='\\#/properties?id=#=id#' title='#:name#'><span>#:name#</span></a></div>"
                + "<div class='button delButton'><a href='javascript:;'><span><i class='histButton fa fa-times' /></i></span></a></div>"
                + "</div>");
            $history.append(tmpl(that.m_history[i]));
        }
        $history.find("div.delButton").on("click", function () {
            const $item = $(this).closest("div.item");
            if (!$item.hasClass("disabled")) {
                const id = $(this).closest("div.item").attr("data-id");
                that.deleteHistoryEntry(id);
            }
        });
        $history.find("div.favButton").on("click", function () {
            const $item = $(this).closest("div.item");
            if (!$item.hasClass("disabled")) {
                if ($item.closest(".sideNav").hasClass("expanded")) {
                    const entry = that.getHistoryEntry($item.attr("data-id"));
                    entry.favorite = !entry.favorite;
                    that.saveHistory();
                    that.renderHistory();
                }
                else
                    window.location.href = $(this).next("div.text").children("a").attr("href");
            }
        });
        that.fixHistoryWidths();
    }
    render() {
        const that = this;
        that.m_layout = new kendo.Layout("<div style='height: 100%;' id='viewHolder'></div>", { wrap: false });
        that.m_layout.render("#contentPane");
        $(".copyrightYear").text(new Date().getFullYear().toString());
        $(".copyright > a").on("click", function () { Utilities_1.synUtil.impressum(); });
        that.renderStaticButtons();
        that.renderChangeButtons();
        that.renderHistory();
    }
    checkUserLoggedin() {
        const that = this;
        clearTimeout(that.m_checkLogonTimeoutId);
        that.m_checkLogonTimeoutId = window.setTimeout(() => {
            Utilities_1.synUtil.logonCheck({
                done: (data) => {
                    that.noConnectionOverlay(false, false);
                    that.m_checkAutoLogOffSeconds = Math.round(data.timeoutSeconds) + 10;
                    that.checkUserLoggedin();
                },
                fail: (jqXHR, status, errorThrown, url) => {
                    if (jqXHR.readyState === 0) {
                        if (that.m_checkUserLoggedInNoConnectionFirstDetected == undefined) {
                            that.m_checkUserLoggedInNoConnectionFirstDetected = new Date();
                            that.m_checkAutoLogOffSeconds = SynApp.CheckUserLoggedInNoConnectionRetryIntervalMillis / 1000;
                            that.checkUserLoggedin();
                        }
                        else {
                            const diff = Date.now() - that.m_checkUserLoggedInNoConnectionFirstDetected.getTime();
                            if (diff > SynApp.CheckUserLoggedInNoConnectionGracePeriodMillis)
                                that.noConnectionOverlay(true, true);
                            else if (diff > SynApp.CheckUserLoggedInNoConnectionWarningPeriodMillis)
                                that.noConnectionOverlay(true, false);
                            that.m_checkAutoLogOffSeconds = SynApp.CheckUserLoggedInNoConnectionRetryIntervalMillis / 1000;
                            that.checkUserLoggedin();
                        }
                    }
                    else
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, status, errorThrown, url);
                },
                skipAutoLogon: true
            });
        }, that.m_checkAutoLogOffSeconds * 1000);
    }
    refreshAppContainer() {
        const that = this;
        clearTimeout(that.m_resizeWidgetsTimeoutId);
        that.m_resizeWidgetsTimeoutId = window.setTimeout(function () { that.resizeWidgets(); }, 300);
    }
    resizeWidgets(resizeMenu = true) {
        const that = this;
        if (resizeMenu && that.m_selectedView)
            that.m_selectedView.resizeMenu();
        const contentSplitter = $("#contentPane").data("kendoSplitter");
        if (contentSplitter)
            kendo.resize($("#contentPane"), false);
        $("#contentPane").children("div").css("height", "100%");
        const $splitter = $("#contentPane").find(".k-splitter").each((idx, elem) => {
            const splitter = $(elem).data("kendoSplitter");
            if (splitter)
                kendo.resize($(elem), false);
        });
        if (that.m_selectedView)
            that.m_selectedView.resizeControls();
    }
    raiseFocus() {
        if (this.m_selectedView)
            this.m_selectedView.onWindowFocus();
    }
    raiseBlur() {
        if (this.m_selectedView)
            this.m_selectedView.onWindowBlur();
    }
    showUI(show, overlayText) {
        $("#appOverlay").css("display", (show ? "none" : ""));
        $("#loadingOverlayText").html("");
        if (!show && overlayText)
            $("#loadingOverlayText").text(overlayText);
    }
    noConnectionOverlay(show, purgeDOM) {
        const $noConnectionOverlay = $("#noConnectionOverlay");
        if (show) {
            if ($noConnectionOverlay.is(":visible") && purgeDOM === $noConnectionOverlay.data("domPurged"))
                return;
            $noConnectionOverlay.css("display", "");
            if (purgeDOM) {
                $(".appContainer").html("");
                $noConnectionOverlay.data("domPurged", true);
            }
            else
                $noConnectionOverlay.data("domPurged", false);
        }
        else {
            if (!$noConnectionOverlay.is(":visible"))
                return;
            if ($noConnectionOverlay.data("domPurged")) {
                window.onbeforeunload;
                window.location.replace(tdBasePath);
            }
            else
                $noConnectionOverlay.css("display", "none");
        }
    }
}
//#endregion CONSTRUCTORS
//#region CONSTANTS
SynApp.SideNavMinWidth = 40;
SynApp.SideNavMaxWidth = 200;
SynApp.MaxHistoryItems = 10;
// Retry interval if synUtil.logonCheck() fails due to network connectivity issues
SynApp.CheckUserLoggedInNoConnectionRetryIntervalMillis = 500;
// Warning period after the first network connectivity issue. After this period, a warning overlay will be displayed.
SynApp.CheckUserLoggedInNoConnectionWarningPeriodMillis = 3000;
// Grace period after the first network connectivity issue. After this period, DOM state will be purged and the
// requestVerificationToken will be removed.
SynApp.CheckUserLoggedInNoConnectionGracePeriodMillis = 30000;
window.waitConditions = new WaitConditions_1.WaitConditions();
window.waitData = new WaitConditions_1.WaitData();
new SynApp().run();
